"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWishlist = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconWishlist = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.75 21.45V2.9h6.308c.23-.572.613-1.056 1.152-1.454A3.025 3.025 0 0 1 12.055.85c.691 0 1.306.199 1.845.596.538.398.92.882 1.142 1.454h6.308v18.55H2.75ZM4.9 19.3h14.3V5.05H4.9V19.3Zm2-1.94h7.25v-2.15H6.9v2.15Zm0-4.11h10.3V11.1H6.9v2.15Zm0-4.11h10.3V6.99H6.9v2.15Zm5.15-4.894a.729.729 0 0 0 .75-.75.728.728 0 0 0-.75-.75.729.729 0 0 0-.75.75.728.728 0 0 0 .75.75Z"
}));
exports.IconWishlist = IconWishlist;
//# sourceMappingURL=IconWishlist.js.map